import axios from "../../utils/axios";

export class DEService {
  createDES(patientId: string, data: any) {
    return axios.post(`/patient/${patientId}/diabetic-eye-screening`, data);
  }

  getDES(patientId: string, desId?: number) {
    const queryString = desId ? `?desId=${desId}` : "";
    return axios.get(`/patient/${patientId}/diabetic-eye-screening${queryString}`);
  }

  updateDES(patientId: string, id: number, data: any) {
    return axios.patch(`/patient/${patientId}/diabetic-eye-screening/${id}`, data);
  }

  handoverDES(patientId: string, id: number, data: any) {
    return axios.post(`/patient/${patientId}/diabetic-eye-screening/${id}/handover`, data);
  }
}